import { Syncable } from "shared/state/models/syncable";
import { IBMPData } from "shared/api/api";

export const SYNC_BMP = 'SYNC_BMP';

export interface BMPState extends Syncable<IBMPData> { }